/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { MdBlock } from 'react-icons/md'

/** Home for a signed-in user whose company or profile has every app switched off. */
const NoAppsPage: React.FC = () => (
  <div className="flex h-full items-center justify-center p-4">
    <div className="card w-full max-w-md bg-base-100 shadow-xl">
      <div className="card-body items-center text-center">
        <MdBlock className="mb-2 text-5xl text-base-content/40" />
        <h1 className="card-title">No apps enabled</h1>
        <p className="text-base-content/70">
          Your account doesn&apos;t have any Insights apps switched on. Contact your administrator to get access.
        </p>
      </div>
    </div>
  </div>
)

export default NoAppsPage
